import { createContext, useState, useEffect } from "react";
import t from "prop-types";
import { toast } from "react-toastify";
import { Trans } from "@lingui/macro";

const speechToTextErrorToastId = "avoid-duplicate-toast-speech-to-text-error";

export const AppContext = createContext();

const VOICES_PRESELECTED = ["Google US English", "Samantha"];
export const SPEECH_LANGUAGES = {
  ES: "es-US",
  EN: undefined,
};

const UserProvider = (props) => {
  const { children } = props;
  
  // Language
  const [allowToSetLanguage, setAllowToSetLanguage] = useState(true);
  const [language, setLanguage] = useState("he");
  
  // Speech
  const [synth] = useState(window.speechSynthesis);
  const [selectedVoice, setSelectedVoice] = useState();
  
  const selectVoice = () => {
    const voices = synth?.getVoices();

    let voice;
    voices.some((el) => {
      if (VOICES_PRESELECTED.includes(el.name)) {
        voice = el;
        return true;
      }
      return false;
    });

    if (!voice) {
      voice = voices.find(el => el.lang.startsWith("en-US")) || voices.find(el => el.lang.startsWith("en"));
    }
    setSelectedVoice(voice);
  };

  const speak = (text, rate = 0.75, lang = SPEECH_LANGUAGES.EN, pitch = 1, volume = 0.6, onStartFunc, onEndFunc) => {
    synth?.cancel();
    if (text) {
      const utterThis = new SpeechSynthesisUtterance(text);
      
      utterThis.voice = selectedVoice || undefined;
      utterThis.rate = rate;
      utterThis.volume = volume;
      utterThis.pitch = pitch;
      utterThis.lang = lang;
      
      utterThis.onstart = () => { onStartFunc && onStartFunc(); };
      utterThis.onend = () => { onEndFunc && onEndFunc(); };
      utterThis.onerror = () => { console.error("SpeechSynthesisUtterance.onerror"); };
      if (synth) {
        synth.speak(utterThis);
      } else {
        toast.error(<Trans>Speech to text is not supported on this device, ask an adult to contact support</Trans>, { toastId: speechToTextErrorToastId });
      }
    }
  };

  useEffect(() => {
    synth?.getVoices();

    if (synth) {
      synth.onvoiceschanged = () => { selectVoice(); };
    }

    // safari doesn't fire onvoiceschanged event
    setTimeout(() => {
      if (!selectedVoice) {
        selectVoice();
      }
    }, 1200);
  }, [synth]);

  window.amplioSpeak = speak; // not sure why would we need this "speak" in the global app context??
  // this is causing issues for other components that need this "speak" that are not part of juno-client (monorepo-lib)
  // I really really don't understand why this "speak" needs to be here..... -- Gal A, 9-March-2022

  return (
    <AppContext.Provider
      value={{
        language,
        setLanguage,
        allowToSetLanguage,
        setAllowToSetLanguage,
        speak,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default UserProvider;

UserProvider.propTypes = {
  children: t.oneOfType([t.array, t.element]),
};
